import React, { Fragment } from 'react';
import '../../styles/scss/style.scss';

export const Pricing = () => {
  return (
    <Fragment>
      <div className="container" style={{ marginTop: "10rem" }} id="pricing">
        <div className="comparison animated bounce">
          <div className="comparison__title">
            <h2 className="comparison__lead">Become productive in your design process </h2>
            <p className="comparison__sub-title text-center">
              As a designer or startup owner you can get your design tasks done in record time instead of spending hours creating new components and pages.
              <br /> <strong>Get a limited lifetime deal which includes future updates of Loop Pro X at a dicounted pre order price now </strong>
            </p>
          </div>
          <div className="comparison__wrap" style={{ padding: "0rem 12%" }}>
            <div className="comparison__box bg-dark text-light">
              <div className="comparison__price">Personal</div>
              <h2 className="comparison__package-name">$39</h2>
              <p>For personal use.</p>
              <ul className="comparison__list2">
                <li className="good">Personal License</li>
                <li className="good">Figma files</li>
                <li className="good">Color Variables</li>
                <li className="good">Color Palettes and typography </li>
                <li className="good">Free fonts and icons</li>
                <li className="good"><strong>1000+ </strong>UI components</li>
                <li className="good"><strong>40+</strong> pages</li>
                <li className="good"><strong>Dark mode</strong> components and pages</li>
                <li className="good">Mobile page version</li>
                <li className="good">Desktop page version</li>
              </ul>
              <a href="https://gum.co/mIqpl" data-gumroad-single-product="true" className="btn1 btn__inverse btn__full">
                Pick for Personal use
              </a>
            </div>
            <div className="comparison__box bg-dark text-light">
              <div className="comparison__price">Team</div>
              <h2 className="comparison__package-name">$72</h2>
              <p>For Team use.</p>
              <ul className="comparison__list2">
                <li className="good">Team License</li>
                <li className="good">Figma files</li>
                <li className="good">Color Variables</li>
                <li className="good">Color Palettes and typography </li>
                <li className="good">Free fonts and icons</li>
                <li className="good"><strong>1000+ </strong>UI components</li>
                <li className="good"><strong>40+</strong> pages</li>
                <li className="good"><strong>Dark mode</strong> components and pages</li>
                <li className="good">Mobile page version</li>
                <li className="good">Desktop page version</li>
              </ul>
              <a href="https://gum.co/mIqpl" data-gumroad-single-product="true" className="btn1 btn__inverse btn__full">
                Pick for Team use
              </a>

            </div>
          </div>
        </div>
        <p className="comparison__footer-info">* Secured payment through Gumroad</p>
      </div>
    </Fragment>
  );
};
